export default __webpack_public_path__ + "static/media/sc_logo.8fba01ba.svg";